const s = "styles-module__extras___hWr7X", t = {
  extras: s
};
export {
  t as default,
  s as extras
};
